import React from "react";
import { Box, Breadcrumbs, Breadcrumb } from "@origin-digital/ods-core";
import styled from "styled-components";
import { Skeleton } from "@origin-digital/ods-lab";
import { BreadCrumbsSkeleton } from "./BreadCrumbsSkeleton";

interface BreadCrumbsProps {
  breadcrumbs: { label: string; url: string }[];
  isLoading?: boolean;
  noOfSkeletons?: number;
}

// Add important to override default styles from MUI
const StyledBreadcrumbs = styled(Breadcrumbs)`
  font-size: 12px !important;
  color: ${(props) => props.theme.colors.neutralDark} !important;
  & span {
    font-size: 12px !important;
    color: ${(props) => props.theme.colors.neutralDark} !important;
  }
  a:not([aria-current]) {
    text-decoration: underline;
  }
`;

const StyledBreadcrumb = styled(Breadcrumb)`
  font-size: 12px !important;
  color: ${(props) => props.theme.colors.neutralDark} !important;
  & span {
    font-size: 12px !important;
    color: ${(props) => props.theme.colors.neutralDark} !important;
  }
`;

export const BreadCrumbs: React.FC<BreadCrumbsProps> = ({
  breadcrumbs,
  isLoading,
  noOfSkeletons,
}) => {
  const isLastItem = (index: number) => index === breadcrumbs.length - 1;

  if (isLoading) {
    return <BreadCrumbsSkeleton numberOfSkeletons={noOfSkeletons || 2} />;
  }

  return (
    <Box
      marginBottom={{ xs: "large", lg: "xlarge" }}
      data-id="breadcrumbs-container"
    >
      <StyledBreadcrumbs
        muiProps={{ "aria-label": "breadcrumb", color: "neutralDark" }}
        data-id="breadcrumbs"
      >
        {breadcrumbs.map((breadcrumb, index) => (
          <StyledBreadcrumb
            data-id={`breadcrumb-item-${index}`}
            key={breadcrumb.url || index}
            href={isLastItem(index) ? undefined : breadcrumb.url}
            active={isLastItem(index)}
          >
            {breadcrumb.label}
          </StyledBreadcrumb>
        ))}
      </StyledBreadcrumbs>
    </Box>
  );
};
